var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVoiceMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.5,
    height: 21.5,
    viewBox: "0 0 17.5 21.5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2056",
    d: "M13.75 9.75V5.75C13.75 2.98858 11.5114 0.75 8.75 0.75C5.98858 0.75 3.75 2.98858 3.75 5.75V9.75C3.75 12.5114 5.98858 14.75 8.75 14.75C11.5114 14.75 13.75 12.5114 13.75 9.75Z",
    strokeWidth: 1.5,
    stroke: "#295FAD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.75 9.75C16.75 14.1683 13.1683 17.75 8.75 17.75M8.75 17.75C4.33172 17.75 0.75 14.1683 0.75 9.75M8.75 17.75V20.75M8.75 20.75H11.75M8.75 20.75H5.75",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    stroke: "#295FAD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoiceMic);
export default __webpack_public_path__ + "static/media/icon-voice-mic.50b90dbc6937c5447a7f293f87f95425.svg";
export { ForwardRef as ReactComponent };